module.exports = __webpack_public_path__ + "static/media/FooterLogo-Clipsal@2x.56038414.png";